import { render, staticRenderFns } from "./TouristInfo.vue?vue&type=template&id=0c3974da&scoped=true&"
import script from "./TouristInfo.vue?vue&type=script&lang=js&"
export * from "./TouristInfo.vue?vue&type=script&lang=js&"
import style0 from "./TouristInfo.vue?vue&type=style&index=0&id=0c3974da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3974da",
  null
  
)

export default component.exports